import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import withAuthentication from 'components/withAuthentication';
import LoginPage from '../LoginPage';
import useSplitTreatment from 'hooks/useSplitTreatment';
import { SplitIO } from 'types';
import LoadingPage from 'pages/LoadingPage';

const QFFRoute = ({
  component: Component,
  isSSO,
  isAuthenticating,
  isAuthenticatedWithSSO,
  hasInitializedSSO,
  setAuthToSSO,
  ...routeProps
}) => {
  const { isReady } = useSplitTreatment(SplitIO.Split.SELF_SERVICE_OAUTH, SplitIO.Treatment.ON);

  useEffect(() => {
    setAuthToSSO();
  }, [setAuthToSSO]);

  if (!isReady || isAuthenticating) {
    return <LoadingPage />;
  }

  return (
    <Route
      {...routeProps}
      render={(props) =>
        isAuthenticatedWithSSO ? (
          <Component {...props} isSSO={isSSO} />
        ) : (
          <LoginPage data-testid="login-form" isSSO={true} hasInitializedSSO={hasInitializedSSO} />
        )
      }
    />
  );
};

export default withAuthentication(QFFRoute);
